// import http from './../../../base/api/public'
// let service = require('@/../config/serviceList')
// let sysConfig = require('@/../config/sysConfig')
// let apiPre = sysConfig.apiPre
// service.res = ''
// export default {
//   getCards (params) {
//     console.log('params:' + JSON.stringify(params))
//     return http.requestPost(apiPre + service.res + '/card/getList', params)
//   }
// }
// 导入基本公共资源
import http from './../../../base/api/public'

let sysConfig = require('@/../config/sysConfig')
let service = require('@/../config/serviceList')
    // 定义访问网关的api,分为开发，测试，以及生产环境
let apiPre = sysConfig.apiPre
export default {
    // 设备
    getPiles(params) {
        console.log('params:' + JSON.stringify(params))
        return http.requestPost(apiPre + service.res + '/res/pile/getPiles', params)
    },
    getStationById(params) {
        console.log('params:' + JSON.stringify(params))
        return http.requestPost(apiPre + service.res + '/res/station/getStationById', params)
    },
    // 
    getRateDateViaCondition(params) {
        console.log('params:' + JSON.stringify(params))
        return http.requestPost(apiPre + service.res + '/res/station/getRateDateViaCondition', params)
    },
    getPileTypeById(params) {
        console.log('params:' + JSON.stringify(params))
        return http.requestPost(apiPre + service.res + '/res/pileType/getPileTypeById', params)
    },
    pileTypeForSelect() {
        return http.requestGet(apiPre + service.res + '/res/pileType/pileTypeForSelect')
    },
    saveOrUpdatePile(params) {
        console.log('params:' + JSON.stringify(params))
        return http.requestPut(apiPre + service.res + '/res/pile/saveOrUpdatePile', params)
    },
    updatePile(params) {
        console.log('params:' + JSON.stringify(params))
        return http.requestPut(apiPre + service.res + '/res/pile/updatePile', params)
    },
    deletePile(params) {
        console.log('params:' + JSON.stringify(params))
        return http.requestPost(apiPre + service.res + '/res/pile/deletePile', params)
    },
    getPileEnum(params) {
        console.log('params:' + JSON.stringify(params))
        return http.requestGet(apiPre + service.res + '/res/pile/getPileEnum', params)
    },
    getRateNameById(params) {
        console.log('params:' + JSON.stringify(params))
        return http.requestPost(apiPre + service.res + '/res/rate/getRateNameById', params)
    },
    getRateSelectByOperatorId(params) {
        console.log('params:' + JSON.stringify(params))
        return http.requestPost(apiPre + service.res + '/res/rate/getRateSelectByOperatorId', params)
    },
    bindingRate(params) {
        console.log('params:' + JSON.stringify(params))
        return http.requestPost(apiPre + service.res + '/res/pile/bindingRate', params)
    }
}


// WEBPACK FOOTER //
// ./src/module/resourceCenter/api/pileApi.js